import { fireTag } from '@nuxt-common/util/app/utils/tagManager';

export function fireLinkTag(payload) {
  fireTag('link', payload);
}

export function fireViewTag(payload) {
  fireTag('view', payload);
}

export default { fireLinkTag, fireViewTag };
